// @noflow
import DaySelectorItem from './item';
import { isDependentOn } from '~/core/utils/custom-prop-types';
import { momentObj } from 'react-moment-proptypes';
import PropTypes from 'prop-types';
import * as React from 'react';
import { DaySelectorList } from './styles';
import { daysBetween } from '~/core/utils/periods';

const DaySelector = ({ endDay, onSelectDay, selectedDay, startDay }) => (
    <DaySelectorList data-qa="day-selector-base">
        {daysBetween(startDay, endDay).map(day => (
            <li key={day.format('DD-MM')}>
                <DaySelectorItem
                    day={day}
                    onSelect={e => {
                        e.preventDefault();
                        onSelectDay(day.format('YYYY-MM-DD'));
                    }}
                    selected={day.isSame(selectedDay, 'day')}
                />
            </li>
        ))}
    </DaySelectorList>
);

DaySelector.propTypes = {
    endDay: isDependentOn(['startDay'], (value, startDay) => value.isAfter(startDay), momentObj.isRequired),
    onSelectDay: PropTypes.func,
    selectedDay: momentObj.isRequired,
    startDay: momentObj.isRequired
};

export default DaySelector;



// WEBPACK FOOTER //
// ./src/components/widgets/day-selector/index.js